import React, { useEffect, useState } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import "../styles/Profile.css";

const Profile = ({ userEmail, onProfileUpdate }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState(userEmail || "");
  const [photo, setPhoto] = useState(null);
  const [area, setArea] = useState("");
  const [phone, setPhone] = useState("");
  const [bio, setBio] = useState("");
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("profileData"));
    if (savedData) {
      setName(savedData.name || "");
      setEmail(savedData.email || "");
      setArea(savedData.area || "");
      setPhone(savedData.phone || "");
      setBio(savedData.bio || "");
      setUserType(savedData.userType || "");
    }
  }, []);

  const areasInPune = [
    "Aundh", "Kothrud", "Pimpri-Chinchwad", "Hinjewadi", "Wakad", "Hadapsar",
    "Baner", "Viman Nagar", "Pune Cantonment", "Shivaji Nagar", "Erandwane", "Koregaon Park"
  ];

  const userTypes = ["Residential", "Commercial"];

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(URL.createObjectURL(file));
    }
  };

  const handleLogout = () => {
    alert("You have logged out successfully!");
  };

  const handleSave = () => {
    const profile = { name, email, area, phone, bio, userType };
    localStorage.setItem("profileData", JSON.stringify(profile));
    alert("Profile updated successfully!");
    if (onProfileUpdate) {
      onProfileUpdate(profile);
    }
  };

  return (
    <div className="profile-container">
      <h2>Profile</h2>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="profile-photo">
          <label>Profile Photo:</label>
          <input type="file" accept="image/*" onChange={handlePhotoChange} />
          {photo && <img src={photo} alt="Profile" />}
        </div>

        <div className="input-group">
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="input-group">
          <label>Email:</label>
          <input type="email" value={email} readOnly />
        </div>

        <div className="input-group">
          <label>Phone Number:</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Enter your phone number"
          />
        </div>

        <div className="input-group">
          <label>Area in Pune:</label>
          <select value={area} onChange={(e) => setArea(e.target.value)} required>
            <option value="">Select Area</option>
            {areasInPune.map((area, index) => (
              <option key={index} value={area}>{area}</option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <label>User Type:</label>
          <select value={userType} onChange={(e) => setUserType(e.target.value)} required>
            <option value="">Select Type</option>
            {userTypes.map((type, index) => (
              <option key={index} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <label>Bio:</label>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            placeholder="Tell us about yourself"
          />
        </div>

        <button type="submit" onClick={handleSave} className="save-btn">
          Save Profile
        </button>
      </form>

      <div className="logout-btn">
        <button onClick={handleLogout}>
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </div>
  );
};

export default Profile;
